import React, { useState, useEffect } from 'react';
import OutputType from './ComponentsTpes/OutputType';

const AlarmOut = ({ selectedType, fieldsData, componentSourceOptions, selectedPorts, setSelectedPorts,
    savedData, setSavedData
}) => {
    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Alarm_out: {
                    ...prevData.Alarm_out,
                    [key]: value
                }
            }
        })
    }

    return <OutputType
        selectedPorts={selectedPorts}
        setSelectedPorts={setSelectedPorts}
        source={componentSourceOptions.outputsData}
        selectOptions={selectOptions}
        component_source={savedData.Alarm_out.component_source.value}
        condition={savedData.Alarm_out.condition}
        output={savedData.Alarm_out.output}
        selectedType={savedData.Alarm_out.selectedType}
        name={savedData.Alarm_out.name}
        relay_mode={savedData.Alarm_out.relay_mode}
        impulse_time={savedData.Alarm_out.impulse_time}
        entry_exit_open_durations={savedData.Alarm_out.entry_exit_open_durations}
        sensorAutolock={savedData.Alarm_out.sensorAutolock}
        fieldsData={fieldsData}
    />
}

export default AlarmOut;